import { ServiceStatus } from "@/enums/ServiceStatus";

type TooltipText = Partial<Record<keyof typeof ServiceStatus, string>>;

const tooltipText: TooltipText = {
  AwaitingApproval: 'ServiceStatus.AwaitingApprovalInfo',
  Approved: 'ServiceStatus.ApprovedInfo',
  Completed: 'ServiceStatus.CompletedInfo',
  Rejected: 'ServiceStatus.RejectedInfo',
  Cancelled: 'ServiceStatus.Cancelled',
};

export const getTooltipTextKey = (status: ServiceStatus) => {

  switch (status) {
    case ServiceStatus.Approved:
      return tooltipText.Approved;
    case ServiceStatus.AwaitingApproval:
      return tooltipText.AwaitingApproval;
    case ServiceStatus.Completed:
      return tooltipText.Completed;
    case ServiceStatus.Rejected:
      return tooltipText.Rejected;
    case ServiceStatus.Cancelled:
      return tooltipText.Cancelled;
    default:
      return status;
  }
};
